import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Report from "./pages/Report/Report";
import "./App.scss";

const App: React.FC = () => {
  return (
    <Router>
      <div className="app">
        <div className="arrow green"></div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/report" element={<Report />} />
        </Routes>
        <div className="arrow red"></div>
      </div>
    </Router>
  );
};

export default App;
